import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute , ParamMap} from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-account-order-view',
  templateUrl: './account-order-view.component.html',
  styleUrls: ['./account-order-view.component.css']
})
export class AccountOrderViewComponent implements OnInit {

  pageName = "Order Details";

  cartItems = [];
  shippingCostValue = 0;
  totalExcludingTax = 0;
  tax = 0;
  totalOrderPaid = 0;
  modelData;
  orderRef = "";
  orderStatus = ""
  userId
  backOrderId 

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private route: ActivatedRoute,
    private _ecomm: CommerceDataService
  ) { }

  ngOnInit() {

    $('#initialise-page').trigger('click');

    this.userId = sessionStorage.getItem('context')

    if(!this.userId) {
        $('#loader').hide();
        // redirect to login 
        this.router.navigate(['/account/login']);
    }
    
    let backOrder = this.route.snapshot.paramMap.get('id');
    this.backOrderId = backOrder

    this.getBackOrderDetails(backOrder)
  }

  getOrderDetails(id) {
    let queryData = new FormData();
    queryData.append('modelName', 'Order');
    queryData.append('mid', id);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {
          this.modelData = data['covers'][0]['cover']['model']['modelData'];
          this.shippingCostValue = this.modelData['systemManagedEntities']['paymentDetails']['shippingTotal'];
          this.totalOrderPaid = this.modelData['systemManagedEntities']['paymentDetails']['total'];
          this.totalExcludingTax = this.modelData['systemManagedEntities']['paymentDetails']['totalProductsCost'];
          this.tax = this.modelData['systemManagedEntities']['paymentDetails']['total_tax'];
          this.cartItems = JSON.parse(this.modelData['formFieldsEntities']['cartItems']['products']);

          console.log(this.cartItems)
        },
        error => {

            $('#loader').hide();

        },

        () => {
          $('#loader').hide();
          // this.reviewOrderSummary()
        }
      );
  }

  getBackOrderDetails(backOrder) {
    let queryData = new FormData();
    queryData.append('modelName', 'BackOrder');
    queryData.append('mid', backOrder);
    queryData.append('context_id', this.userId);


      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.modelData = data['covers'][0]['cover']['model']['modelData'];
          this.orderStatus = this.modelData['systemManagedEntities']['orderDetails']['status'];
          let orderId = this.modelData['systemManagedEntities']['orderDetails']['orderId'];
          this.orderRef = this.modelData['systemManagedEntities']['orderDetails']['refNumber'];
          this.getOrderDetails(orderId)
        },
        error => {

            $('#loader').hide();

        },

        () => {
          $('#loader').hide();
          // this.reviewOrderSummary()
        }
      );
  }

}
